class OffersApi {
    getFullOfferData(locale, expiredOfferId) {
        return fetch('/' + locale + '/offers/get-full-offer-data.json?id=' + expiredOfferId)
            .then(function (response) {
                return response.json();
            });
    }

    getShallowOfferData(locale, expiredOfferId) {
        return fetch('/' + locale + '/offers/get-shallow-offer-data.json?id=' + expiredOfferId)
            .then(function (response) {
                return response.json();
            });
    }

    getCreateOptions(locale) {
        return fetch('/' + locale + '/offers/create-options.json')
            .then(function (response) {
                return response.json();
            });
    }

    createOffer(offerData, locale, csrfToken) {
        return fetch('/' + locale + '/offers/save.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(offerData),
            redirect: "manual"
        });
    }

    renewOffer(offerData, locale, csrfToken) {
        return fetch('/' + locale + '/offers/renewOffer.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(offerData),
            redirect: "manual"
        });
    }

    reconditionOffer(offerData, locale, csrfToken) {
        return fetch('/' + locale + '/offers/reconditionOffer.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(offerData),
            redirect: "manual"
        });
    }

    editOffer(offerData, locale, csrfToken) {
        return fetch('/' + locale + '/offers/edit/' + offerData.id + '.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(offerData),
            redirect: "manual"
        });
    }
}

export default new OffersApi();
